/**
 * This key holds an encoded URI representing the redirect location after a log out is
 * finished. The value is an initialism representing "redirect path and query string".
 */
export const redirectURIKey = 'rpaqs';

/** We want to know if a password-protected short ID has been verified this session to prevent prefetches. */
export const getKeyForShortIDVerificationStatus = (shortID: string) => `${shortID}-sidvs`;

/** Session storage key to check if saml has been enforced in an
 * enterprise workspace that an account belongs to
 */
export const SAML_SSO_ENFORCED = 'SAML SSO enforced';

/**
 * Sentinel flag set by the confirm-email page just before redirecting to
 * `/login`, so the login page can fire a "new email verified" toast on
 * arrival. Does NOT store the email address — the frontend can't derive
 * it from the verify token, and the user may even land here from a
 * logged-out session, so we keep the message generic.
 */
export const EMAIL_CHANGE_VERIFIED_KEY = 'emailChangeVerified';

/** Stores the pre-gate path while a user verifies a newly created account email. */
export const EMAIL_VERIFICATION_REQUIRED_REDIRECT_KEY = 'emailVerificationRequiredRedirect';
